module.exports = __webpack_public_path__ + "assets/img/illust_03.c18bf954.png";